import defaultSchema from './default.schema';

export default {
  ...defaultSchema,

  title: 'Zmiana hasła',
  type: 'object',
  properties: {
    password: {
      type: 'string',
      title: 'Podaj swoje hasło',
      fieldRequired: true
    },
    newPassword: {
      type: 'string',
      title: 'Nowe hasło',
      fieldRequired: true,
      minLength: 14,
      validFunc: 'return new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[^A-Za-z0-9]).{14,}$").test($value)',
      validationMessages: {
        required: 'Hasło jest wymagane',
        minLength: 'Minimalna długość hasła wynosi 14',
        validFunc: 'Hasło powinno zawierać co najmniej jedną dużą literę, jedną małą literę, cyfrę oraz znak specjalny'
      }
    },
    confirmPassword: {
      type: 'string',
      title: 'Powtórz nowe hasło',
      computed: true,
      fieldRequired: true,
      validFunc: '$value && this.newPassword ? $value === this.newPassword : true',
      validationMessages: {
        required: 'Powtórzenie hasła jest wymagane',
        validFunc: 'Oba hasła muszą być takie same'
      }
    }
  }
};
